import { cloudFunctionsService } from '@/data/services/cloudFunctionsService';

/**
 * DeleteAccountDataUseCase
 * 
 * Deletes all user account data.
 * Throws error on failure - no remapping needed for void operations.
 */
export class DeleteAccountDataUseCase {
    async execute(): Promise<void> {
        await cloudFunctionsService.deleteAccountData();
    }
}

export const deleteAccountDataUseCase = new DeleteAccountDataUseCase();
